import { render, staticRenderFns } from "./CreatedMind.vue?vue&type=template&id=0a438535&scoped=true"
import script from "./CreatedMind.vue?vue&type=script&lang=js"
export * from "./CreatedMind.vue?vue&type=script&lang=js"
import style0 from "./CreatedMind.vue?vue&type=style&index=0&id=0a438535&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a438535",
  null
  
)

export default component.exports